import { render, staticRenderFns } from "./CardNewDrawer.vue?vue&type=template&id=224fcbea&"
import script from "./CardNewDrawer.vue?vue&type=script&lang=js&"
export * from "./CardNewDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports